// Import all GLB assets statically so Vite can process and hash them
// This ensures proper cache busting with content hashes
import { FoamPackageType, FOAM_PACKAGE_TYPES } from './foot';

// Superrev insoles
import superrevLeftFoot from '../assets/glb/superrev/LeftFoot.glb?url';
import superrevRightFoot from '../assets/glb/superrev/RightFoot.glb?url';

// Superrev Elite insoles
import superrevEliteLeftFoot from '../assets/glb/superrev_elite/LeftFoot.glb?url';
import superrevEliteRightFoot from '../assets/glb/superrev_elite/RightFoot.glb?url';

// Ribbing assets
import ribbingLeftLight from '../assets/glb/ribbing/left_light.glb?url';
import ribbingLeftHeavy from '../assets/glb/ribbing/left_heavy.glb?url';
import ribbingRightLight from '../assets/glb/ribbing/right_light.glb?url';
import ribbingRightHeavy from '../assets/glb/ribbing/right_heavy.glb?url';
import { useGLTF } from '@react-three/drei';

// Type-safe GLB asset mapping
export const GLB_ASSETS = {
	superrev: {
		LeftFoot: superrevLeftFoot,
		RightFoot: superrevRightFoot,
	},
	superrev_elite: {
		LeftFoot: superrevEliteLeftFoot,
		RightFoot: superrevEliteRightFoot,
	},
	ribbing: {
		left_light: ribbingLeftLight,
		left_heavy: ribbingLeftHeavy,
		right_light: ribbingRightLight,
		right_heavy: ribbingRightHeavy,
	},
} as const;

// Helper function to get insole GLB URLs
export const getInsoleGlb = (
	foamPackageType: FoamPackageType,
	foot: 'LeftFoot' | 'RightFoot'
): string => {
	return GLB_ASSETS[foamPackageType][foot];
};

// Helper function to get ribbing GLB URLs
export const getRibbingGlb = (
	foot: 'left' | 'right',
	weight: 'light' | 'heavy'
): string => {
	return GLB_ASSETS.ribbing[`${foot}_${weight}` as keyof typeof GLB_ASSETS.ribbing];
};

export const preloadInsoleGlb = (foamPackageType: FoamPackageType, foot: 'LeftFoot' | 'RightFoot') => {
	useGLTF.preload(getInsoleGlb(foamPackageType, foot));
};

export const preloadRibbingGlb = (foot: 'left' | 'right', weight: 'light' | 'heavy') => {
	useGLTF.preload(getRibbingGlb(foot, weight));
};

export const preloadAllInsoleGlbs = () => {
	preloadInsoleGlb(FOAM_PACKAGE_TYPES.SUPERREV, 'LeftFoot');
	preloadInsoleGlb(FOAM_PACKAGE_TYPES.SUPERREV, 'RightFoot');
	preloadInsoleGlb(FOAM_PACKAGE_TYPES.SUPERREV_ELITE, 'LeftFoot');
	preloadInsoleGlb(FOAM_PACKAGE_TYPES.SUPERREV_ELITE, 'RightFoot');
};

export const preloadAllRibbingGlbs = () => {
	preloadRibbingGlb('left', 'light');
	preloadRibbingGlb('left', 'heavy');
	preloadRibbingGlb('right', 'light');
	preloadRibbingGlb('right', 'heavy');
};

export const preloadAllGlbs = () => {
	preloadAllInsoleGlbs();
	preloadAllRibbingGlbs();
};
